import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "../components/legal/LegalLayout";
import { company } from "../legal/company";

const sections = [
  {
    id: "acceptance",
    title: "1. Acceptance of these terms",
    content: (
      <p>
        These Terms of Use govern your access to and use of{" "}
        {company.website.replace("https://", "")} (the "website"), operated by{" "}
        {company.legalName || company.name}. By using the website, you agree to
        these terms. If you do not agree, please do not use the website.
      </p>
    ),
  },
  {
    id: "website-content",
    title: "2. Information on this website",
    content: (
      <>
        <p>
          The website presents our company, our services and examples of our
          work. Its content is provided for general information only. We work
          to keep it accurate and up to date, but we cannot guarantee that it
          is complete or error-free at all times.
        </p>
        <p>
          Nothing on the website is a binding offer. Any project we carry out
          for you is governed by a separate written proposal, quote or
          contract, which prevails over these terms.
        </p>
      </>
    ),
  },
  {
    id: "acceptable-use",
    title: "3. Acceptable use",
    content: (
      <>
        <p>When using the website, you agree not to:</p>
        <ul>
          <li>use it for any unlawful, fraudulent or harmful purpose;</li>
          <li>
            attempt to gain unauthorized access to the website, its servers or
            related systems, or interfere with their operation;
          </li>
          <li>
            send spam, malicious code or automated mass requests through the
            contact form or the AI assistant;
          </li>
          <li>
            copy, scrape or reuse the website's content for commercial purposes
            without our written permission.
          </li>
        </ul>
        <p>
          We may limit or block access to the website or its features in case
          of misuse.
        </p>
      </>
    ),
  },
  {
    id: "ai-assistant",
    title: "4. AI assistant",
    content: (
      <>
        <p>
          The chat on this website is an automated assistant powered by a
          third-party AI model. Its answers are generated automatically and
          may be inaccurate, incomplete or out of date. They do not constitute
          professional advice, a quote or a commitment from Code Solutions.
        </p>
        <p>
          Do not share confidential or sensitive information in the chat. How
          we handle chat data is described in our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>
      </>
    ),
  },
  {
    id: "intellectual-property",
    title: "5. Intellectual property",
    content: (
      <>
        <p>
          The website and its content, including text, design, graphics, the
          Code Solutions name and logo, are owned by Code Solutions or its
          licensors and are protected by intellectual property laws. You may
          view and share pages of the website for personal or internal
          business use. Any other reproduction, modification or distribution
          requires our prior written consent.
        </p>
        <p>
          Third-party names, logos and trademarks shown on the website, such
          as those of technology providers, belong to their respective owners
          and are used only to identify the technologies we work with.
        </p>
      </>
    ),
  },
  {
    id: "third-party-links",
    title: "6. Third-party links",
    content: (
      <p>
        The website contains links to third-party websites and services (for
        example LinkedIn, GitHub, Facebook, Instagram and WhatsApp). We do not
        control them and are not responsible for their content or privacy
        practices. Your use of them is subject to their own terms.
      </p>
    ),
  },
  {
    id: "liability",
    title: "7. Disclaimer and limitation of liability",
    content: (
      <>
        <p>
          The website is provided "as is" and "as available". We do not
          guarantee that it will be uninterrupted, secure or free of errors or
          viruses.
        </p>
        <p>
          To the extent permitted by applicable law, Code Solutions is not
          liable for any indirect or consequential loss arising from your use
          of, or inability to use, the website or the information it
          contains, including answers given by the AI assistant. Nothing in
          these terms limits liability that cannot be limited under the law.
        </p>
      </>
    ),
  },
  {
    id: "privacy",
    title: "8. Privacy",
    content: (
      <p>
        Personal data you provide through the website is processed according
        to our <Link to="/privacy-policy">Privacy Policy</Link> and our{" "}
        <Link to="/cookie-policy">Cookie Policy</Link>.
      </p>
    ),
  },
  {
    id: "changes",
    title: "9. Changes to these terms",
    content: (
      <p>
        We may update these terms from time to time. The updated version
        applies from the date shown at the top of this page. Continuing to use
        the website after a change means you accept the updated terms.
      </p>
    ),
  },
  {
    id: "governing-law",
    title: "10. Governing law and jurisdiction",
    content: (
      <p>
        These terms are governed by the laws of the Kingdom of Morocco. Any
        dispute relating to the website that cannot be resolved amicably will
        be submitted to the competent courts of Rabat.
      </p>
    ),
  },
  {
    id: "contact",
    title: "11. Contact",
    content: (
      <p>
        Questions about these terms? Contact us at{" "}
        <a href={`mailto:${company.email}`}>{company.email}</a> or{" "}
        <a href={company.phoneHref}>{company.phone}</a>.
      </p>
    ),
  },
];

const TermsOfUse = () => (
  <LegalLayout
    title="Terms of Use"
    description="The terms that apply when you use the Code Solutions website, including its contact form and AI assistant."
    intro="These terms set out the rules for using our website, its contact form and AI assistant. Please read them carefully."
    path="/terms-of-use"
    sections={sections}
  />
);

export default TermsOfUse;
